import React from "react";
import connect from "Shared/connect";
import { translate } from "Shared/translate";
import FeedbackButton from "Shared/Button/Feedback";
import { Input, Checkbox } from "Shared/Fields";
import { parseUrl } from "Shared/url";
import classnames from "classnames";
import { SMALL } from "Shared/breakpoints";
import { login as loginAction, } from "../../action-creators";
import * as styles from "./base.scss";
class LoginBox extends React.Component {
    constructor(props) {
        super(props);
        let presetcustomerId = "";
        let presetPassword = "";
        let presetCheckbox = false;
        if (props.loginModel) {
            presetcustomerId = props.loginModel.customerId;
            presetPassword = props.loginModel.password;
            presetCheckbox = props.loginModel.rememberMe;
        }
        this.state = {
            customerId: presetcustomerId,
            password: presetPassword,
            rememberMe: presetCheckbox,
            loginMessage: null,
            messageType: null,
        };
    }
    doLogin() {
        this.setState({ loginMessage: null, messageType: null });
        const customerId = this.state.customerId.trim();
        if (!customerId) {
            this.customerIdElement.focus();
            return;
        }
        const password = this.state.password.trim();
        if (!password) {
            this.passwordElement.focus();
            return;
        }
        this.feedbackButton.activate(this.props
            .loginAction({
            customerId: customerId,
            password,
            rememberMe: this.state.rememberMe,
        })
            .then(() => {
            this.props.close();
        })
            .catch((e) => {
            this.setState({
                loginMessage: !!e.message
                    ? e.message
                    : translate("/Account/Login/ServerError"),
                messageType: "fail",
            });
            return Promise.reject(null);
        }));
    }
    openPolicyLink(url) {
        if (url) {
            window.open(url, "_system");
        }
    }
    onSubmit(e) {
        e.preventDefault();
        this.doLogin();
    }
    render() {
        return (React.createElement(React.Fragment, null,
            React.createElement("form", { onSubmit: (e) => this.onSubmit(e), className: styles.loginForm },
                this.state.loginMessage && this.state.messageType && (React.createElement("div", { className: classnames({
                        [styles.loginMessageFail]: this.state.messageType === "fail",
                        [styles.loginMessageOk]: this.state.messageType === "success",
                    }) }, this.state.loginMessage || this.props.message)),
                this.props.message && (React.createElement("div", { className: styles.messageInfo }, this.props.message)),
                React.createElement(Input, { type: "text", name: "username", autoFocus: this.props.currentBreakpoint <= SMALL
                        ? false
                        : this.props.isCurrent, required: true, value: this.state.customerId, ref: (el) => (this.customerIdElement = el), placeholder: translate("/Account/Login/EmailorIDFieldTitle"), onChange: (e) => this.setState({
                        customerId: e.target.value,
                        loginMessage: null,
                        messageType: null,
                    }) }),
                React.createElement(Input, { type: "password", name: "password", required: true, value: this.state.password, ref: (el) => (this.passwordElement = el), placeholder: translate("/Account/Login/PasswordFieldTitle"), onChange: (e) => this.setState({
                        password: e.target.value,
                        loginMessage: null,
                        messageType: null,
                    }) }),
                React.createElement("div", { className: styles.belowInputsArea },
                    React.createElement(Checkbox, { checked: this.state.rememberMe, onChange: (e) => this.setState({
                            rememberMe: e.target.checked,
                            loginMessage: null,
                        }) }, translate("/Account/Login/RememberMe"))),
                React.createElement("div", { className: styles.belowInputsArea },
                    React.createElement(FeedbackButton, { ref: (c) => (this.feedbackButton = c), type: "submit", appearance: "secondary", className: "ui-test-submit-button" }, "translate(\"/Account/Login/Login\")"))),
            React.createElement("div", { className: styles.footer },
                React.createElement("div", { className: styles.footerInner },
                    React.createElement("div", { className: styles.signUpText }, translate("/Account/Registration/NotCustomerYet")),
                    React.createElement("div", null,
                        React.createElement("a", { href: this.props.signUpUrl, className: styles.signUpLink, onClick: () => this.props.close() }, translate("/Account/Registration/SignUpForMenigo")))))));
    }
}
export default connect((state) => ({
    message: state.accountBox.message,
    redirectToAfterLogin: parseUrl(state.accountBox.redirectToAfterLogin.href),
    currentBreakpoint: state.currentBreakpoint,
    loginModel: state.appShellData.header.loginModel,
}), (dispatch) => ({
    loginAction: (details) => dispatch(loginAction(details)),
}))(LoginBox);
